/** The catalogue's warnings about a module, as the editor shows them.
 *
 *  The server sends each one as a code and its numbers
 *  (`layout/tronsoane.py`, `CatalogError.cod`); the sentence is built here in
 *  the reader's language. Nothing blocks on them: the module saves and
 *  publishes, and a module that only falls short of a rule is still composed
 *  by the site plan (team ruling, 03.11.2026). */
import { numar, t, type Cheie } from "../../../i18n";
import { ro } from "../../../i18n/ro";

export type Avertisment = {
  cod: string;
  date: Record<string, unknown>;
  /** The server's English sentence, shown when the code is unknown here. */
  mesaj: string;
};

/** Values that name something the reader should see in their own words. */
const TRADUSE: Record<string, string> = {
  camera: "editor.abatere_camera.",
  ce: "editor.abatere_ce.",
};

function valoare(cheie: string, v: unknown): string {
  if (typeof v === "number") {
    // The server counts dwellings from 0; the plan labels them from 1.
    if (cheie === "locuinta") return String(v + 1);
    return numar(v, { maximumFractionDigits: 2 });
  }
  if (Array.isArray(v)) return v.map((x) => valoare(cheie, x)).join(", ");
  const s = v == null ? "" : String(v);
  const prefix = TRADUSE[cheie];
  if (prefix && `${prefix}${s}` in ro) return t(`${prefix}${s}` as Cheie);
  return s;
}

export function textulAvertismentului(a: Avertisment): string {
  const cheie = `editor.abatere.${a.cod}`;
  if (!(cheie in ro)) return a.mesaj;
  const valori: Record<string, string> = {};
  for (const [k, v] of Object.entries(a.date ?? {})) valori[k] = valoare(k, v);
  return t(cheie as Cheie, valori);
}
